import { gql } from '@apollo/client';
import baseImage from './baseImage';
import finance from './finance';
import disclaimer from './disclaimer';
import prices from './prices';

const stockCars = {
  STOCK_CARS: gql`
    ${baseImage.BASE_IMAGE}
    ${finance.FINANCE}
    ${disclaimer.DISCLAIMER}
    ${prices.PRICES}
    fragment StockCars on StockCar {
      carId
      vin
      disclaimer {
        ...Disclaimer
      }
      selectedFeatures {
        selected
        added
        removed
        merged {
          merged
          into
        }
        requiresOneOf
      }
      images {
        ...BaseImage
      }
      prices {
        ...Prices
        source
      }
      finance(financeFormInput: $financeFormInput) {
        ...Finance
        disclaimers {
          value
          needsToBeTranslated
        }
      }
      carMatchLabel
      keyFeatures {
        id
        shortname
        shortDescription
        longDescription
        code
        categoryCode
      }
    }
  `,
};
export default stockCars;
